import { React, useEffect, useState } from 'react';
import styled from 'styled-components';
import Lottie from 'lottie-react';

import FetchModule from '../../Share/Network/FetchModule';
import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';
import TotalModalWrapper from '../../Share/Normal/TotalModalWrapper';

import { ReactComponent as CardIconSvg } from '../../../image/Card.svg';
import LoadingAnimation from '../../../Animation/LoadingAnimation.json';

export default function BillingInfoModal(props) {
  const { data, onClickExit } = props;
  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [isInProgress, setIsInPregress] = useState(false);

  const [cardName, setCardName] = useState('');
  const [cardNum, setCardNum] = useState('');
  const [suspensionCode, setSuspensionCode] = useState('');
  const [suspensionReason, setSuspensionReason] = useState('');


  useEffect(() => {
    setCardName(data.cardName === undefined ? '' : data.cardName);
    setCardNum(data.cardNum === undefined ? '' : data.cardNum);
    setSuspensionCode(data.suspensionCode === undefined ? '' : data.suspensionCode);
    setSuspensionReason(data.suspensionReason === undefined ? '' : data.suspensionReason);
  }, [data])

  // 정기결제 클릭시 페이플 버전 //
  function onClickRegularPaymentOnPayple() {
    const obj = {};

    obj.PCD_PAY_TYPE = 'card'
    obj.PCD_PAY_WORK = 'AUTH'
    obj.PCD_CARD_VER = '01';
    obj.PCD_PAYER_AUTHTYPE = 'sms';

    obj.callbackFunction = getResult;
    obj.clientKey = '0F44C92BFB07F1BE60C5235A7254316D';

    window.PaypleCpayAuthCheck(obj);
  }

  // 결제 이후 콜백 //
  function getResult(res) {
    if (res.PCD_PAY_RST === 'success' && (res.PCD_PAY_CODE === '0000' || res.PCD_PAY_CODE === 'CDAU1000')) {
      let requestData = {
        billingKey: res.PCD_PAYER_ID,
        cardName: res.PCD_PAY_CARDNAME,
        cardNum: res.PCD_PAY_CARDNUM
      }

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('billing/registry', 'POST', requestData);

          if (responseData.status === 200) {
            alert(t('myStoreSetting.billingInfo.cardRegistered'));
            onClickExit();
          }
          else {
            onClickExit();
          }
        }
      )();
    }
    else {
      if (res.PCD_PAY_CODE === undefined) {
        alert(res.PCD_PAY_MSG);
      }
      else {
        alert('[' + res.PCD_PAY_CODE + ']' + ' ' + res.PCD_PAY_MSG);
      }
    }
  }

  // 재결제하기 클릭시 //
  function onClickRetryBilling() {
    if (isInProgress) {
      alert(t('myStoreSetting.billingInfo.paymentInProgress'));
      return;
    }

    setIsInPregress(true);

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('billing/retry/zone', 'POST');
        
        if (responseData.status === 200) {
          alert(t('myStoreSetting.billingInfo.paymentComplete'));
          setIsInPregress(false);
          onClickExit();
        }
        else {
          alert(responseData.error);
          setIsInPregress(false);
        }
      }
    )();
  }


  return (
    <TotalModalWrapper>
      {
        isInProgress ?
          <LottieWrapper>
            <LottieWrapper>
              <Lottie animationData={LoadingAnimation} loop={true} />
            </LottieWrapper>
          </LottieWrapper>
          :
          <ModalView>
            <TitleWrapper>
              <TitleTextWrapper>
                <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.text} cursor='default'>{t('myStoreSetting.billingInfo.title')}</Text>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{t('myStoreSetting.billingInfo.description')}</Text>
              </TitleTextWrapper>
              <ExitButton onClick={onClickExit}>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='pointer'>{t('myStoreSetting.cancel')}</Text>
              </ExitButton>
            </TitleWrapper>
            <InfoBoxWrapper>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('myStoreSetting.billingInfo.registeredCard')}</Text>
              <InfoBox>
                <CardSvg />
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{cardName} / {cardNum}</Text>
              </InfoBox>
            </InfoBoxWrapper>
            <InfoBoxWrapper>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('myStoreSetting.billingInfo.paymentAvailability')}</Text>
              <InfoBox>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{suspensionCode === '' ? t('myStoreSetting.billingInfo.available') : suspensionReason}</Text>
              </InfoBox>
            </InfoBoxWrapper>
            <ButtonWrapper>
              <Button onClick={onClickRetryBilling}>
                <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.subBackground} cursor='pointer'>{t('myStoreSetting.billingInfo.retryPayment')}</Text>
              </Button>
              <Button onClick={onClickRegularPaymentOnPayple}>
                <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.subBackground} cursor='pointer'>{t('myStoreSetting.billingInfo.registerOtherCard')}</Text>
              </Button>
            </ButtonWrapper>
          </ModalView>
      }
    </TotalModalWrapper>
  )
}

const LottieWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 80px;
  height: 80px;
`;

const ModalView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  padding: 20px 0px;

  width: 407px;

  border-radius: 10px;
  background-color: ${props => props.theme.subBackground};
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 90.33%;
`;

const TitleTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 4px;
`;

const InfoBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 16px;

  width: 90.33%;
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0px 10px;
  margin-top: 8px;

  width: calc(100% - 20px);
  height: 33px;

  gap: 10px;

  background-color: ${props => props.theme.background};
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  margin-top: 16px;

  width: 90.33%;
`;

const Button = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 48.5%;
  height: 43px;

  border-radius: 10px;
  background-color: ${props => props.theme.line};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      background-color: ${props => props.theme.subKey};
    }
  }

  transition: all 0.3s ease-in-out;
`;

const CardSvg = styled(CardIconSvg)`
  width: 18px;
  height: 18px;

  & rect {
    stroke: ${props => props.theme.text};
  }
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 62px;
  height: 40px;

  border-radius: 10px;
  background-color: ${props => props.theme.buttonFill};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;
  
  margin: 0 0 0 0;
  
  color: ${props => props.color};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.cursor};
    }
  }
`;
